// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bcw_a bho_b bho_va bho_rv bho_rw bho_vu","PanelFooter--link":"bcw_b"};